exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.double-ctrl-wrap>tbody>tr>td {\n\tpadding-right: 5px;\n    vertical-align: middle;\n}\n", ""]);
